/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppRequestsQueryVariables = Types.Exact<{
  kind: Types.AppRequestsKindEnum;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type IAppRequestsQuery = {
  __typename?: 'Query';
  appRequests: {
    __typename?: 'AppRequestPage';
    nodesCount: number;
    pagesCount: number;
    nodes: Array<{
      __typename?: 'AppRequest';
      id: string;
      appName?: string | null;
      contactEmail: string;
      contactName: string;
      description: string;
      declineReason?: string | null;
      status: Types.AppRequestStatusEnum;
      requesterCompanyName: string;
      requesterCompanyWebsite: string;
      vendorName: string;
      policy: { __typename?: 'AppRequestPolicy'; accept: boolean; decline: boolean };
    }>;
  };
};

export const AppRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appRequests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppRequestsKindEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kind' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pagesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppRequestFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppRequestFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declineReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decline' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requesterCompanyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requesterCompanyWebsite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendorName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppRequestsQuery, IAppRequestsQueryVariables>;
